const token = localStorage.getItem('authToken');

export const Api = {

  // //* On Development    
  // API_BASE_URL: 'http://localhost:3001/api/',

  //! On Production
   API_BASE_URL: 'https://builderplaybook.net/api/',

  //     --------------------------

  //* on development
  IMAGE_BASE_URL: 'http://192.168.29.93:3001/',

  //! on production
  //  IMAGE_BASE_URL: 'http://35.239.153.120:3001/',


  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
}

